module.exports = __webpack_public_path__ + "static/media/Fes.4eac0dbb.png";